import { InjectionToken } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export interface IGuardedLogout {
  guardedLogout$(dialog: MatDialog): Observable<unknown>;
}

/** The menu logout (active Nora recording check, then confirmation), bound to AudioRecorderService in CoreModule. */
export const GUARDED_LOGOUT = new InjectionToken<IGuardedLogout>('GUARDED_LOGOUT');
